var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Avatar } from "../Avatar";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawer-avatar",
};
const DrawerAvatar = (_a) => {
    var { children, avatarProps, title, subtitle, className } = _a, rest = __rest(_a, ["children", "avatarProps", "title", "subtitle", "className"]);
    const classList = classNames("tecma-drawer-avatar", className);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx(Avatar, Object.assign({ size: "large" }, avatarProps)), _jsxs("div", { className: "drawer-avatar-info", children: [title && _jsx("span", { className: "drawer-avatar-title", children: title }), subtitle && _jsx("span", { className: "drawer-avatar-subtitle", children: subtitle })] })] })));
};
DrawerAvatar.defaultProps = defaultProps;
export default React.memo(DrawerAvatar);
